<template>
	<div class="relogio">
		<div class="remaining">Remaining time</div>
		<div class="clock" style="height: 50px">
			{{ this.relogio }}
		</div>
		<div class="labels">
			<span class="hr">Hour</span>
			<span class="mn">Minutes</span>
			<span class="sg">Seconds</span>
		</div>
	</div>
</template>

<script>
	import moment from 'moment'
	import bus from '@/bus/event-bus.js'

	export default {
		props: ['restante', 'locked'],

		data() {
			return {
				moment: null,
				relogio: '',
				seconds: null
			}
		},

		watch: {
			restante() {
				this.pulse()
			},
			seconds(v) {
				if(v != null) {
					if(v == 0) {
						setTimeout(() => {
							bus.$emit('relogio.ping')
						}, 1000)
					}
				}
			}
		},

		mounted() {
			this.moment = moment().startOf('day').add(this.restante, 'seconds')
			this.pulse()
			if(!this.locked) {
				
				this.startClock()
			}
		},

		methods: {
			startClock() {
				var i = setInterval(() => {
					if(!this.hasEnded()) {
						this.pulse()
					} else {
						this.seconds = this.moment.second()
						clearInterval(i)
					}
				}, 1000)
			},
			hasEnded() {
				var start = moment().startOf('day');
				return this.moment.isSameOrBefore(start);
			},
			pulse() {
				if(this.hasEnded()) {
					this.relogio = "00:00:00"
					bus.$emit('relogio.acabou');
				} else {
					this.moment.add(-1, 'seconds')
					this.seconds = this.moment.second()
					this.relogio = this.moment.format('HH:mm:ss')
				}
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/Relogio.vue